import React from 'react';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useCondition } from '../../../hooks/questionnaire/useCondition';
import { operatorTranslationKeys } from '@/features/questionnaires';
import { QuestionnaireFormData } from '@/features/questionnaires';
import { SelectInput } from '@/shared';

interface ConditionOperatorSelectProps {
  questionIndex: number;
  conditionIndex: number;
  disabled?: boolean;
}

export const ConditionOperatorSelect: React.FC<
  ConditionOperatorSelectProps
> = ({ questionIndex: questionIndex, conditionIndex: conditionIndex }) => {
  const form = useFormContext<QuestionnaireFormData>();
  const { t } = useTranslation();
  const { path, operators } = useCondition(questionIndex, conditionIndex);

  return (
    <SelectInput
      form={form}
      name={`${path}.conditions.${conditionIndex}.operator`}
      label={t('pages.studies.questions.conditions.condition')}
      sx={{ minWidth: '180px' }}
    >
      {operators.map((op) => (
        <MenuItem key={op} value={op}>
          {t(operatorTranslationKeys[op])}
        </MenuItem>
      ))}
    </SelectInput>
  );
};
